import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';
import LoginView from './views/LoginView.vue';
import OnboardingView from './views/OnboardingView.vue';
import CourseMapView from './views/CourseMapView.vue';
import PracticeView from './views/PracticeView.vue';
import ParentView from './views/ParentView.vue';
import ResetPasswordView from './views/ResetPasswordView.vue';
import ReviewView from './views/ReviewView.vue';
import SentencePracticeView from './views/SentencePracticeView.vue';
import SettingsView from './views/SettingsView.vue';
import { useAuthStore } from './stores/auth';
import { useLearnerStore } from './stores/learner';

export const cl_router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', component: LoginView, meta: { cl_public: true } },
    { path: '/reset-password', component: ResetPasswordView, meta: { cl_public: true } },
    { path: '/onboarding', component: OnboardingView },
    { path: '/', component: HomeView },
    { path: '/map', component: CourseMapView },
    { path: '/lesson/:cl_slug', component: PracticeView },
    { path: '/lesson/:cl_slug/sentences', component: SentencePracticeView },
    { path: '/review', component: ReviewView },
    { path: '/parent', component: ParentView },
    { path: '/settings', component: SettingsView },
  ],
  scrollBehavior: () => ({ top: 0 }),
});

cl_router.beforeEach(async (cl_to) => {
  const cl_auth = useAuthStore();
  if (!cl_auth.cl_ready) await cl_auth.cl_restore();
  if (cl_to.meta.cl_public) return cl_auth.cl_authenticated ? '/' : true;
  if (!cl_auth.cl_authenticated) return '/login';
  const cl_learner = useLearnerStore();
  if (!cl_learner.cl_children.length) await cl_learner.cl_load();
  if (!cl_learner.cl_activeChild && cl_to.path !== '/onboarding') return '/onboarding';
  return true;
});
